/* Round twenty-one (2026-08-30), delivery: the navigation's inline script
   (sections/cl-nav.liquid) as a cacheable asset, loaded with defer. One
   init per [data-cl-nav] root; the body is the round-twenty script
   unchanged, the root lookup by section id replaced by the scan below. */
(function () {
  function init(root) {
  if (!root || root.dataset.clNavReady === '1') return;
  root.dataset.clNavReady = '1';

  var TABLET  = window.matchMedia('(max-width: 991px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FADE  = 220;   // the stage and overlay fades, keep in step with cl-nav.css
  var SLIDE = 260;   // the cross-slide between two panels

  var strip  = root.querySelector('.cl-nav__top');
  var bar    = root.querySelector('[data-cl-bar]');
  var stage  = root.querySelector('[data-cl-stage]');
  var box    = root.querySelector('[data-cl-panels]');
  var scrim  = root.querySelector('[data-cl-scrim]');
  var drawer = root.querySelector('[data-cl-drawer]');
  var burger = root.querySelector('[data-cl-nav-burger]');
  var closer = root.querySelector('[data-cl-nav-close]');

  function slice(list) { return Array.prototype.slice.call(list); }
  var toggles = slice(root.querySelectorAll('[data-cl-dd-toggle]'));
  var panels  = box ? slice(box.querySelectorAll('[data-cl-dd-panel]')) : [];

  /* ---------- runtime measurements ------------------------------------- */

  // --cl-nav-strip-h is the strip's height. The root (and, on Shopify, the
  // .shopify-section wrapper it sits in) is position: sticky with top set to
  // minus this, which is what lets the strip scroll away while the bar stays.
  // --cl-nav-h is the bar's bottom edge in viewport px; other sections may
  // read it, so it stays a px value on the section root.
  var wrap = root.parentElement && root.parentElement.classList && root.parentElement.classList.contains('shopify-section')
    ? root.parentElement : null;
  var lastStrip = null, lastH = null, lastG = null, lastB = null;

  function measure() {
    var s = strip ? Math.round(strip.getBoundingClientRect().height) : 0;
    if (s !== lastStrip) {
      lastStrip = s;
      root.style.setProperty('--cl-nav-strip-h', s + 'px');
      if (wrap) wrap.style.setProperty('--cl-nav-strip-h', s + 'px');
    }
    var h = bar ? Math.round(bar.getBoundingClientRect().bottom) : 0;
    if (h !== lastH) { lastH = h; root.style.setProperty('--cl-nav-h', h + 'px'); document.documentElement.style.setProperty('--cl-nav-h', h + 'px'); }
    // --cl-nav-bar-h: the height of the part that stays stuck (the bar), constant while
    // scrolling. Sizes that must not jump as the marquee and strip scroll away (the
    // product gallery's cap) read this instead of --cl-nav-h.
    var bh = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    if (bh && bh !== lastB) { lastB = bh; document.documentElement.style.setProperty('--cl-nav-bar-h', bh + 'px'); }
    // The overlay is fixed to the viewport while the bar sits inside the
    // page's outer margin, so the overlay's gutter is taken from where the
    // bar's logo actually starts; the CSS 5% is only the pre-script fallback.
    var logo = bar ? bar.querySelector('.navbar5_logo-link') : null;
    var g = logo ? Math.round(logo.getBoundingClientRect().left) : 0;
    if (g > 0 && g !== lastG) { lastG = g; root.style.setProperty('--cl-nav-gutter', g + 'px'); document.documentElement.style.setProperty('--cl-nav-gutter', g + 'px'); }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; measure(); });
  }

  measure();
  window.addEventListener('resize', measure);
  window.addEventListener('scroll', onScroll, { passive: true });
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(measure);
    if (strip) ro.observe(strip);
    if (bar) ro.observe(bar);
  }

  /* ---------- desktop mega panels, one shared box ----------------------- */

  var openIndex = -1;
  var hoverTimer = null;
  var stageTimer = null;

  function park(panel) {
    clearTimeout(panel._clTimer);
    panel.classList.remove('is-active', 'is-leaving', 'is-entering');
    panel.setAttribute('hidden', '');
  }

  // a leaving panel is hidden once its slide has had time to finish
  function settle(panel) {
    clearTimeout(panel._clTimer);
    panel._clTimer = setTimeout(function () { park(panel); }, REDUCED.matches ? 0 : SLIDE + 40);
  }

  function syncToggles() {
    toggles.forEach(function (t, i) {
      var on = i === openIndex;
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
      t.classList.toggle('is-open', on);
    });
  }

  function openDD(i) {
    if (!stage || !box || TABLET.matches) return;
    var next = panels[i];
    if (!next || i === openIndex) return;

    var prev = openIndex >= 0 ? panels[openIndex] : null;
    var first = !prev;

    clearTimeout(stageTimer);
    // anything still fading out from an earlier close goes away at once
    panels.forEach(function (p) { if (p !== next && p !== prev) park(p); });

    // Direction of travel through the bar: a later dropdown enters from the
    // right and pushes the outgoing one out to the left, and the reverse
    // coming back. The box does not move, it only changes height.
    stage.classList.remove('is-forward', 'is-back');
    if (!first) stage.classList.add(i > openIndex ? 'is-forward' : 'is-back');

    if (first) {
      scrim.removeAttribute('hidden');
      stage.removeAttribute('hidden');
      root.classList.add('is-dd-open');
    }

    clearTimeout(next._clTimer);
    next.classList.remove('is-leaving', 'is-active');
    next.removeAttribute('hidden');
    next.classList.add('is-entering');
    // Every panel is as wide as the box whatever the box's height, so the
    // height can be read before the box has grown to it. The read also
    // commits the entry offset, and on the first open it commits the box's
    // resting height of 0 (closeAll clears the inline value), so the
    // assignment animates the box open from the bar downwards while the
    // rows rise into it: the reveal is the box growing over its content.
    box.style.height = next.offsetHeight + 'px';

    window.requestAnimationFrame(function () {
      next.classList.remove('is-entering');
      next.classList.add('is-active');
      stage.classList.add('is-open');
      scrim.classList.add('is-on');
    });

    if (prev) {
      clearTimeout(prev._clTimer);
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      settle(prev);
    }

    openIndex = i;
    syncToggles();
  }

  function closeAll(focusBack) {
    if (openIndex < 0 || !stage) return;
    var panel = panels[openIndex];
    var was = openIndex;
    openIndex = -1;
    syncToggles();

    // no direction on the way out: the whole stage fades where it stands and
    // the panel keeps its rows visible underneath the fade
    stage.classList.remove('is-forward', 'is-back', 'is-open');
    scrim.classList.remove('is-on');
    root.classList.remove('is-dd-open');

    clearTimeout(stageTimer);
    var finish = function () {
      park(panel);
      stage.setAttribute('hidden', '');
      scrim.setAttribute('hidden', '');
      box.style.height = '';
    };
    if (REDUCED.matches) finish();
    else stageTimer = setTimeout(finish, FADE);

    if (focusBack && toggles[was]) toggles[was].focus();
  }

  toggles.forEach(function (toggle, i) {
    // A toggle with an href is a link as well as a toggle. The pointer type
    // of the press that produced the click decides: a mouse click follows the
    // link (hover has already opened the panel), a touch tap opens the panel
    // first and follows the link from an open panel, and Enter (detail 0)
    // does the same as touch.
    toggle.addEventListener('pointerdown', function (e) { toggle._clPointer = e.pointerType; });
    toggle.addEventListener('click', function (e) {
      if (TABLET.matches) return;
      var href = toggle.getAttribute('href');
      var keyboard = e.detail === 0;
      var touch = toggle._clPointer === 'touch';
      toggle._clPointer = null;
      if (href) {
        if (!touch && !keyboard) return;          // mouse: navigate
        if (openIndex === i) return;              // second tap / Enter: navigate
        e.preventDefault();
        openDD(i);
        if (keyboard && panels[i]) {
          var head = panels[i].querySelector('a[href], button');
          if (head) head.focus({ preventScroll: true });
        }
        return;
      }
      if (openIndex === i) { closeAll(); return; }
      openDD(i);
      // A keyboard "click" (Enter or Space, detail 0) moves focus into the
      // panel the way a menu button does, so the links are one Tab away
      // rather than five toggles and a CTA away; a pointer click leaves
      // focus on the toggle.
      if (e.detail === 0 && panels[i]) {
        var first = panels[i].querySelector('a[href], button');
        if (first) first.focus({ preventScroll: true });
      }
    });
    toggle.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch' || TABLET.matches) return;
      clearTimeout(hoverTimer);
      openDD(i);
    });
  });

  // Hover intent is on the bar, which contains the stage, so crossing from a
  // toggle into its panel never leaves the bar. The stage is pointer-events:
  // none outside the panel box, so the gutters beside the panel count as out.
  if (bar) {
    bar.addEventListener('pointerenter', function () { clearTimeout(hoverTimer); });
    bar.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch' || TABLET.matches) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { closeAll(); }, 180);
    });
  }

  if (scrim) scrim.addEventListener('click', function () { closeAll(); });

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) closeAll();
  });

  // tabbing out of the nav closes the panel, so keyboard users never leave a
  // stage open over the content they have moved on to
  root.addEventListener('focusout', function (e) {
    if (openIndex < 0) return;
    if (e.relatedTarget && !root.contains(e.relatedTarget)) closeAll();
  });

  /* ---------- mobile drill-down ---------------------------------------- */

  var mpanels = drawer ? slice(drawer.querySelectorAll('[data-cl-panel]')) : [];
  var byId = {};
  mpanels.forEach(function (p) { byId[p.dataset.clPanel] = p; });

  // trail[trail.length - 1] is always the panel on screen. It is only mutated
  // inside goTo, so the outgoing panel can still be identified when animating.
  var trail = ['root'];

  function slide(fromId, toId, direction) {
    var from = byId[fromId], to = byId[toId];
    if (!to || from === to) return;

    to.removeAttribute('hidden');
    to.classList.add(direction === 'forward' ? 'is-entering' : 'is-entering-back');
    void to.offsetHeight;                       // commit the entry transform
    to.classList.remove('is-entering', 'is-entering-back');
    to.classList.add('is-active');

    if (from) {
      from.classList.remove('is-active');
      from.classList.add(direction === 'forward' ? 'is-behind' : 'is-ahead');
      var settleM = function () {
        from.classList.remove('is-behind', 'is-ahead');
        from.setAttribute('hidden', '');
        from.removeEventListener('transitionend', settleM);
        clearTimeout(from._clTimer);
      };
      from.addEventListener('transitionend', settleM);
      from._clTimer = setTimeout(settleM, 400);  // in case the transition never fires
    }

    to.scrollTop = 0;
    var target = to.querySelector('.cl-nav__back, .cl-nav__row');
    if (target) target.focus({ preventScroll: true });
  }

  function goTo(id, direction) {
    var fromId = trail[trail.length - 1];
    if (id === fromId) return;
    if (direction === 'forward') trail.push(id);
    else trail.pop();
    slide(fromId, id, direction);
  }

  function resetDrawer() {
    trail = ['root'];
    mpanels.forEach(function (p) {
      clearTimeout(p._clTimer);
      p.classList.remove('is-active', 'is-behind', 'is-ahead', 'is-entering', 'is-entering-back');
      if (p.dataset.clPanel === 'root') { p.classList.add('is-active'); p.removeAttribute('hidden'); }
      else p.setAttribute('hidden', '');
    });
  }

  // is-menu-open mounts the overlay, is-menu-in fades it in and releases the
  // rows' stagger, is-menu-out holds the rows still while the sheet fades
  // out. Page scroll is locked with html.cl-lock (cl-base.css), never with an
  // inline overflow, so the other overlays' lock and this one cannot fight.
  // Black Friday: the burger's red dot says "something new inside" until the
  // drawer has been opened once this session; the label drops the hint too.
  var BF_KEY = 'cl-bf-menu-seen';
  function bfSeen() {
    if (!root.classList.contains('has-bf')) return;
    root.classList.add('is-bf-seen');
    if (burger && burger.dataset.labelPlain) burger.setAttribute('aria-label', burger.dataset.labelPlain);
    try { sessionStorage.setItem(BF_KEY, '1'); } catch (e) {}
  }
  try { if (sessionStorage.getItem(BF_KEY) === '1') bfSeen(); } catch (e) {}

  var menuTimer = null;
  function setMenu(open, focusBack) {
    if (open === root.classList.contains('is-menu-in')) return;
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (drawer) drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('cl-lock', open);
    clearTimeout(menuTimer);

    if (open) {
      closeAll();
      resetDrawer();
      bfSeen();
      root.classList.remove('is-menu-out');
      root.classList.add('is-menu-open');
      if (drawer) void drawer.offsetWidth;      // commit opacity 0 before the fade
      root.classList.add('is-menu-in');
      if (closer) closer.focus({ preventScroll: true });
    } else {
      root.classList.add('is-menu-out');
      root.classList.remove('is-menu-in');
      var done = function () {
        root.classList.remove('is-menu-open', 'is-menu-out');
        resetDrawer();
      };
      if (REDUCED.matches) done();
      else menuTimer = setTimeout(done, FADE);
      if (focusBack && burger) burger.focus({ preventScroll: true });
    }
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var open = e.target.closest('[data-cl-open]');
      if (open) { goTo(open.dataset.clOpen, 'forward'); return; }
      var back = e.target.closest('[data-cl-back]');
      if (back) { goTo(back.dataset.clBack, 'back'); return; }
      if (e.target.closest('[data-cl-nav-close]')) setMenu(false, true);
    });
  }

  if (burger) {
    burger.addEventListener('click', function () {
      setMenu(!root.classList.contains('is-menu-in'));
    });
  }

  // On document, not on the root: a panel opened by hover has no focus
  // inside the nav, so Escape arrives on <body>.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    // cl-topbar's region and contact drawers and the favourites list are
    // <dialog>s that close themselves on Escape; this must not also close the
    // menu or the panel underneath them. The target is where focus was when
    // the key went down, so it still says "inside the dialog" even after an
    // earlier listener has already closed it.
    if (e.defaultPrevented) return;
    if (e.target && e.target.closest && e.target.closest('dialog')) return;
    if (root.classList.contains('is-menu-in')) {
      if (trail.length > 1) {
        var current = byId[trail[trail.length - 1]];
        goTo(current.dataset.clParent || 'root', 'back');
      } else {
        setMenu(false, true);
      }
      return;
    }
    closeAll(true);
  });

  TABLET.addEventListener('change', function () {
    closeAll();
    setMenu(false);
    measure();
  });
  }
  function scan(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-cl-nav]')) init(scope);
    if (scope.querySelectorAll) Array.prototype.forEach.call(scope.querySelectorAll('[data-cl-nav]'), init);
  }
  /* The tag is emitted once per instance and the theme editor re-inserts it
     with a re-rendered section, so a second run only scans for new roots. */
  if (window.clNavScan) { window.clNavScan(document); return; }
  window.clNavScan = scan;
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
